import { Flex } from '@chakra-ui/react';
import React from 'react';
import './TopicPageSkeleton.scss';
import { useShallow } from 'zustand/react/shallow';

import BreadcrumbSkeleton from '@/components/storyblok/TopicPage/TopicPageSkeleton/BreadcrumbSkeleton/BreadcrumbSkeleton';
import FeaturedThemesCardSectionSkeleton from '@/components/storyblok/TopicPage/TopicPageSkeleton/FeaturedThemesCardSectionSkeleton/FeaturedThemesCardSectionSkeleton';
import FilterAndResultsSectionSkeleton from '@/components/storyblok/TopicPage/TopicPageSkeleton/FilterAndResultsSectionSkeleton/FilterAndResultsSectionSkeleton';
import HeroSectionSkeleton from '@/components/storyblok/TopicPage/TopicPageSkeleton/HeroSectionSkeleton/HeroSectionSkeleton';
import HeroSectionSkeletonNew from '@/components/storyblok/TopicPage/TopicPageSkeleton/HeroSectionSkeletonNew/HeroSectionSkeletonNew';
import { useAppStore } from '@/stores/AppStore';

const TopicPageSkeleton = () => {
  const [isNewDesign] = useAppStore(useShallow(state => [state.isNewDesign]));

  const newDesignClassName = isNewDesign ? 'new-design' : '';

  return (
    <Flex className={`skeleton-loader-container ${newDesignClassName}`}>
      {/*Skeleton loader is only visible when switching between topic pages*/}
      {isNewDesign ? (
        <HeroSectionSkeletonNew />
      ) : (
        <>
          <BreadcrumbSkeleton />
          <HeroSectionSkeleton />
          <FeaturedThemesCardSectionSkeleton />
          <FilterAndResultsSectionSkeleton />
        </>
      )}
    </Flex>
  );
};

export default TopicPageSkeleton;
